(function(){
  'use strict';
  function publish(name,detail){
    if(window.MOOD_EVENTS&&typeof window.MOOD_EVENTS.publish==='function') window.MOOD_EVENTS.publish(name,detail||{});
    document.dispatchEvent(new CustomEvent(name,{detail:detail||{}}));
  }

  var loyalty=document.querySelector('[data-loyalty-page]');
  if(loyalty){
    loyalty.addEventListener('click',function(event){
      var action=event.target.closest('[data-loyalty-action]');
      if(action) publish('mood_loyalty_action',{action:action.getAttribute('data-loyalty-action')});
      var subscription=event.target.closest('[data-subscription-action]');
      if(subscription) publish('mood_subscription_interest',{action:subscription.getAttribute('data-subscription-action')});
    });
    var video=loyalty.querySelector('.mood-loyalty-film video');
    var toggle=loyalty.querySelector('.mood-loyalty-video-toggle');
    if(video&&toggle){
      function syncVideoButton(){var paused=video.paused;toggle.setAttribute('aria-pressed',paused?'true':'false');toggle.setAttribute('aria-label',paused?'הפעלת הסרטון':'השהיית הסרטון');}
      toggle.addEventListener('click',function(){if(video.paused){video.play().catch(function(){});}else video.pause();syncVideoButton();});
      video.addEventListener('play',syncVideoButton);video.addEventListener('pause',syncVideoButton);syncVideoButton();
    }
  }

  document.querySelectorAll('[data-mood-subscription-options]').forEach(function(root){
    var modes=Array.from(root.querySelectorAll('input[name="mood-purchase-mode"]'));
    var select=root.querySelector('[data-selling-plan-select]');
    function sync(){
      var selected=modes.find(function(input){return input.checked;});
      var subscription=selected&&selected.value==='subscription';
      if(select){select.hidden=!subscription;select.disabled=!subscription;}
      root.setAttribute('data-mode',subscription?'subscription':'one-time');
      publish('mood_purchase_mode_selected',{mode:subscription?'subscription':'one_time',selling_plan_id:subscription&&select?select.value:null});
    }
    modes.forEach(function(input){input.addEventListener('change',sync);});
    if(select)select.addEventListener('change',function(){publish('mood_subscription_plan_selected',{selling_plan_id:select.value});});
    sync();
  });

  window.MOOD_SUBSCRIPTIONS={
    selectedPlanId:function(){
      var root=document.querySelector('[data-mood-subscription-options]');
      if(!root||root.getAttribute('data-mode')!=='subscription') return null;
      var select=root.querySelector('[data-selling-plan-select]');
      return select&&!select.disabled&&select.value?Number(select.value):null;
    }
  };
})();
